<div class="start-date-selector">
  <div class="start-date-selector__title" i18n>Choose your start date</div>
  <lx-flexible-start-date-selector-field
    [selectedValue]="selectedStartDate()"
    [selectedStartDate]="selectedStartDate()"
    [selectedEndDate]="selectedEndDate()"
    [calendarConfig]="calendarConfig()"
    (selectedValueChange)="onSelectStartDate($event)"
    data-qa="start-date-selector"
  ></lx-flexible-start-date-selector-field>
</div>
